import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Checkbox, Dimmer, Dropdown, Loader, Modal, Progress, Icon } from 'semantic-ui-react';
import { Perk } from '../Perks/Perk';
import { AppContext } from '../../context/app/appContext';
import { TopBar } from '../common/TopBar';
import { Sidebar } from '../common/Sidebar';
import { toast } from 'react-toastify';
import axios from "axios";

const AddPerksToProgramPageComponent = (props) => {

    // const {id} = useParams();
    const { id } = useParams()
    const [perks, setPerks] = useState([]);
    const [programPerks, setProgramPerks] = useState([]);
    const [programName, setProgramName] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [returnedSearch, setReturnedSearch] = useState([]);
    const [cachedPerks, setCachedPerks] = useState([]);
    const [subMenuActiveItem, setSubMenuActiveItem] = useState('See All');
    const [teamList, setTeamList] = useState([]);
    const [selectedTeams, setSelectedTeams] = useState([]);
    const [existingTeams, setExistingTeams] = useState([]);
    const [approvedPerks, setApprovedPerks] = useState([])

    const [totalUtilization, setTotalUtilization] = useState(0);
    const [totalUtilizationPercentage, setTotalUtilizationPercentage] = useState(0);
    const [totalAvailableBudget, setTotalAvailableBudget] = useState(0);

    const [wellnessPerksPercentage, setWellnessPerksPercentage] = useState(0);
    const [productivityPerksPercentage, setProductivityPerksPercentage] = useState(0);
    const [trainingPerksPercentage, setTrainingPerksPercentage] = useState(0);
    const [lifestylePerksPercentage, setLifestylePerksPercentage] = useState(0);
    const [entertainmentPerksPercentage, setEntertainmentPerksPercentage] = useState(0);
    const [commutePerksPercentage, setCommutePerksPercentage] = useState(0);

    const [showInfoModal, setShowInfoModal] = useState(false);
    const [infoModalText, setInfoModalText] = useState('');

    const [allowApproveAll, setAllowApproveAll] = useState(true)

    const appContext = useContext(AppContext);

    const myRef = React.createRef()

    useEffect(() => {
        console.info({ id });
        // const programId = props.match.params.id;
        // console.info({programId});
        // TODO: getting id of perk-program each time here
        (async () => {
            const currentPerksProgram = await appContext.fetchSinglePerksProgram(id);
            console.info({ currentPerksProgram });
            setProgramPerks(currentPerksProgram.perks);
            setProgramName(currentPerksProgram.name);
        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if(!appContext.perkPrograms.length){
            (async function loadPerkPrograms() {
                await appContext.loadPerkPrograms();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const currPerks = searchQuery.length === 0 ? perks : cachedPerks;
        console.info({currPerks})
        console.info({currLength: currPerks.filter(perk => {return !perk.approved}).length})
        setAllowApproveAll(currPerks.filter(perk => {return !perk.approved}).length > 0)
    }, [programPerks, searchQuery, perks, cachedPerks])

    useEffect(() => {
        const approvedPerksTotal = appContext.perks.reduce((total, perk) => {
            // console.info({perk}, {programPerks});
            // console.info(`programPerks.some(program => program._id === perk.id)`, programPerks.some(program => program._id === perk.id));
            // if (programPerks.includes(perk.id)) {
            const matchedPerks = programPerks.filter(programPerk => programPerk.id === perk.id);
            // console.info({matchedPerks});
            if (matchedPerks.length && matchedPerks[0]) {
                const programPerk = matchedPerks[0];
                const price = programPerk.price ? programPerk.price : perk.price;
                return total + price;
            } else {
                return total;
            }
        }, 0);
        setTotalUtilization(parseFloat(approvedPerksTotal).toFixed(2));
        setTotalUtilizationPercentage(parseInt(approvedPerksTotal / totalAvailableBudget * 100));
        setTotalAvailableBudget(totalAvailableBudget); // TODO: should be remaining amount of issuing balance after other team budget are taken
    }, [appContext.perks, programPerks, totalAvailableBudget]);

    useEffect(() => {
        // TODO: add category utilization percentage
        const totalPerks = programPerks.length;
        console.info({ totalPerks });

        var approvedPerksData = []

        let wellnessPerksCount = 0;
        let productivityPerksCount = 0;
        let trainingPerksCount = 0;
        let lifestylePerksCount = 0;
        let entertainmentPerksCount = 0;
        let commutePerksCount = 0;
        let totalPrice = 0;

        for (const programPerk of programPerks) {
            const perkId = programPerk.id;
            const perkItem = appContext.perks.filter(perk => {
                return perk.id === perkId;
            });

            totalPrice += programPerk.price
            // console.info({perkItem});
            if (perkItem.length && perkItem[0].categories && (perkItem[0].categories.includes('wellness') || perkItem[0].categories.includes('Wellness'))) wellnessPerksCount = wellnessPerksCount + programPerk.price / perkItem[0].categories.length;
            if (perkItem.length && perkItem[0].categories && (perkItem[0].categories.includes('productivity') || perkItem[0].categories.includes('Productivity'))) productivityPerksCount = productivityPerksCount + programPerk.price / perkItem[0].categories.length;
            if (perkItem.length && perkItem[0].categories && (perkItem[0].categories.includes('training') || perkItem[0].categories.includes('Training'))) trainingPerksCount = trainingPerksCount + programPerk.price / perkItem[0].categories.length;
            if (perkItem.length && perkItem[0].categories && (perkItem[0].categories.includes('lifestyle') || perkItem[0].categories.includes('Lifestyle'))) lifestylePerksCount = lifestylePerksCount + programPerk.price / perkItem[0].categories.length;
            if (perkItem.length && perkItem[0].categories && (perkItem[0].categories.includes('entertainment') || perkItem[0].categories.includes('Entertainment'))) entertainmentPerksCount = entertainmentPerksCount + programPerk.price / perkItem[0].categories.length;
            if (perkItem.length && perkItem[0].categories && (perkItem[0].categories.includes('commute') || perkItem[0].categories.includes('Commute'))) commutePerksCount = commutePerksCount + programPerk.price / perkItem[0].categories.length;

            approvedPerksData.push({
                perkName: perkItem.length && perkItem[0].providerName !== undefined ? perkItem[0].providerName : '',
                perkPrice: programPerk.price
            })
        }

        console.info({wellnessPerksCount})
        console.info({productivityPerksCount})
        console.info({trainingPerksCount})
        console.info({lifestylePerksCount})
        console.info({entertainmentPerksCount})
        console.info({commutePerksCount})
        console.info({totalPrice})

        setWellnessPerksPercentage(parseInt(wellnessPerksCount / totalPrice * 100));
        setProductivityPerksPercentage(parseInt(productivityPerksCount / totalPrice * 100));
        setTrainingPerksPercentage(parseInt(trainingPerksCount / totalPrice * 100));
        setLifestylePerksPercentage(parseInt(lifestylePerksCount / totalPrice * 100));
        setEntertainmentPerksPercentage(parseInt(entertainmentPerksCount / totalPrice * 100));
        setCommutePerksPercentage(parseInt(commutePerksCount / totalPrice * 100));

        setApprovedPerks(approvedPerksData)
    }, [programPerks, appContext.perks]);

    useEffect(() => {
        if(appContext.teams.length && appContext.perkPrograms.length){
            const orgPrograms = appContext.perkPrograms;
            const selectedTeams = [];
            const unassignedTeamList = [];
            const inactiveProgramTeams = [];

            for (const team of appContext.teams) {
                if (team.perksProgramId && team.perksProgramId.trim() === id) selectedTeams.push(team);
                if (!team.perksProgramId || team.perksProgramId === "") unassignedTeamList.push(team);
                if (team.perksProgramId && !orgPrograms.filter(program => { return program.id === team.perksProgramId.trim() })[0].active) inactiveProgramTeams.push(team);
            }

            console.info({ unassignedTeamList });

            const allowedTeams = [...selectedTeams, ...unassignedTeamList, ...inactiveProgramTeams];

            const teamList = allowedTeams.map(team => {
                return { key: team.id, value: team.id, text: team.name };
            });

            const selectedTeamIds = selectedTeams.map(team => team.id);

            console.info({ teamList });
            setTeamList(teamList);
            setSelectedTeams(selectedTeamIds);
            setExistingTeams(selectedTeamIds);

            const totalBudget = appContext.teams.reduce((total, team) => {
                const teamSize = team.size === 0 ? 1 : parseInt(team.size);
                console.info({ team }, '');
                return total + (parseInt(team.budget) * teamSize);
            }, 0);
            console.info({ totalBudget });
            setTotalAvailableBudget(totalBudget);
        }
        // eslint-disable-next-line
    }, [appContext.teams, appContext.perkPrograms]);

    useEffect(() => {
        if (!appContext.teams.length) {
            (async function loadTeams() {
                await appContext.loadTeams();
                await appContext.setEmployees();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        appContext.setLoading();
        (async function loadGlobalPerks() {
            await appContext.loadGlobalPerks();
        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if(subMenuActiveItem === 'See All') setPerks(appContext.perks)
        else setPerks(appContext.perks.filter(p => { return p.categories.map(c => { return c.trim().toLowerCase() }).includes(subMenuActiveItem.trim().toLowerCase()) }));
        // console.info(appContext.perks);
        // eslint-disable-next-line
    }, [appContext.perks]);

    const handleSubMenuItemClick = async (e) => {
        e.preventDefault();
        setSearchQuery('')
        const name = e.target.innerText;
        setSubMenuActiveItem(name);

        const categoryName = name.trim().toLowerCase();
        console.info({ categoryName });

        console.info({ globalPerks: appContext.perks });

        const categoryPerks = (categoryName !== 'see all') ? appContext.perks.filter(perk => perk.categories.map(p => { return p.trim().toLowerCase() }).includes(categoryName)) : appContext.perks;

        console.info({ categoryPerks });
        setPerks(categoryPerks);
    };

    const onTeamSelected = (event, { value }) => {
        console.info({ value });
        setSelectedTeams(value);
    };

    const setPerksProgramTeamHandler = async () => {
        console.info({ selectedTeams });
        const teamAssigned = await appContext.assignTeamsToPerkProgram(id, selectedTeams);
        console.info({ teamAssigned });
        if (!teamAssigned) {
            console.info(`Unable to assign teams to the perks program.`);
            setInfoModalText(`Unable to assign teams to the perks program.`);
            setShowInfoModal(true);
            setSelectedTeams(existingTeams);
            setExistingTeams(existingTeams);
        } else {
            setInfoModalText(`Perks program has been updated with the selected team(s).`);
            setShowInfoModal(true);
            setExistingTeams(selectedTeams);
            setSelectedTeams(selectedTeams);
        }
    }

    const cancelHandler = async () => {
        setSelectedTeams(existingTeams);
    }

    const toggleSortProviderNames = () => {
        const sortedPerksByProviderName = [...perks].sort((a, b) => a.providerName > b.providerName ? 1 : -1);
        setPerks(sortedPerksByProviderName);
    };

    const toggleSortPerkPrices = () => {
        const sortedPerksByPrice = [...perks].sort(
            (a, b) => a.price > b.price ? 1 : -1);
        setPerks(sortedPerksByPrice);
    };

    const perkRemoveHandler = async (perkId, perkName) => {
        toast.dark(`${perkName} has been removed from the program.`);
        console.info(`Perk to remove: ${perkId}`);
        const removed = await appContext.removePerkFromPerkProgram(id, perkId);
        console.info({ removed });
        if (removed){ 
            setProgramPerks(programPerks.filter(approvedPerk => approvedPerk.id !== perkId));
            const slackmessageAddperk = await axios.post(
                `http://localhost:8080/slack/message`,
                {
                    "email": "abelp915@gmail.com",
                    "message": "A perk was deleted from your perk program."
                }
            );
        }
    }

    const perkUpdateHandler = async (updatedPerk) => {
        console.info({ updatedPerk });
        toast.success(`${updatedPerk.name} price limit has been updated for the program.`);
        const filteredProgramPerks = programPerks.filter(perk => perk.id !== updatedPerk.id);

        const updatedProgramPerks = [...filteredProgramPerks, updatedPerk];
        console.info({ updatedProgramPerks });
        setProgramPerks(updatedProgramPerks);
    }

    const perkAddHandler = async (perk) => {
        // toast.success(<div><img src={perk.iconURL} alt={perk.providerName}/>{perk.providerName} has been added to the program.</div>);
        toast.success(`${perk.providerName} has been added to the program.`);
        console.info(`Perk to add: ${perk}`);
        const added = await appContext.addPerkToPerkProgram(id, perk);
        console.info({ added });
        var slackmessageAddperk;
        if (added) {
            setProgramPerks([...programPerks, perk]);
            try {
                slackmessageAddperk = await axios.post(
                    `http://localhost:8080/slack/message`,
                    {
                        "email": "abelp915@gmail.com",
                        "message": "Hello, A new perk is added on the platform. Please do check it out"
                    }
                );
                console.info({ slackmessageAddperk })
            }
            catch (error) {
                console.info({ error })
            }
        }
    }

    const approveAllPerks = async () => {
        const allPerks = searchQuery === "" ? perks : cachedPerks;
        const perksToMap = allPerks.filter(perk => {return !perk.approved}).map(perk => {return {
                id: perk.id,
                price: perk.price,
                proiderName: perk.providerName,
                iconURL: perk.iconURL
            }})
        const perksToSend = perksToMap.map(perk => {return {_id: perk.id, priceLimit: perk.price}});
        console.info({perksToSend})
        const added = await appContext.addAllPerksToProgram(id, perksToSend);
        console.info({ added });
        if (added) {
            toast.success(`All perks have been added to the program.`);
            setProgramPerks([...programPerks, ...perksToMap]);
        }
    }

    const searchAlgo = async (input) => {

        setSearchQuery(input)
        if (input !== "") {
            //alogia
            console.log("search query = ", input)

            const algoliaPerks = await axios.post('https://api.perkfix.com/search/algo', { keyword: input })
            console.log("search api = ", algoliaPerks)
            // await setReturnedSearch(algoliaPerks.data)
            const retSearch = algoliaPerks.data
            // console.log("Perks values = ", perks)
            var test1 = []
            const per = perks
            for (let item of retSearch) {
                // console.log("Perks values = ", retSearch[0]['Merchant Name']===item.providerName)
                const test = per.filter(a => { return item['Merchant Name'].toLowerCase() === a.providerName.toLowerCase() })
                if (test.length != 0) {
                    test1.push(test[0])
                }

            }
            setCachedPerks(test1)
            // console.log("matched merchants = ", test1)
            // console.log("matched merchants not = ", perks)

        }
        // setPerks(appContext.perks)

    }

    return (

        <div id="sub-page" style={{ width: '90vw' }}>
            {/* <TopBar/>
            <div id="app-body"> */}

            {appContext.loading && (<Dimmer active inverted>
                <Loader inverted inline='centered'>Loading</Loader>
            </Dimmer>)}
            {/* <div className="ui grid">
                    <div className="three wide column"><Sidebar/></div> */}
            {/* <div id="content" className="thirteen wide column"> */}

            {/* --- page starts from here --- */}
            <div id="add-perks-to-program-page" className="dashboard-page" style={{ width: '90vw' }} ref={myRef}>
                <header style={{ backgroundColor: 'transparent' }}><h3 style={{ backgroundColor: 'transparent', color: 'black' }}>{programName ? `Add Perks to: ${programName}` : 'Perks Program Management'}</h3></header>

                <div className="" style={{ width: '90vw', backgroundColor: '#555555', marginBottom: 15, borderRadius: 2, marginTop: 10, marginBottom: 20 }}>
                    <nav className="ui inverted pointing secondary menu" style={{ width: '100%', paddingLeft: 10 }}>
                        <a href="#top" onClick={handleSubMenuItemClick} className={`item see-all ${subMenuActiveItem === 'See All' ? 'active' : ''}`}>See All</a>
                        <a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'Popular' ? 'active' : ''}`}>Popular</a>
                        <a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'Wellness' ? 'active' : ''}`}>Wellness</a>
                        <a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'productivity' ? 'active' : ''}`}>Productivity</a>
                        <a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'Training' ? 'active' : ''}`}>Training</a>
                        <a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'Lifestyle' ? 'active' : ''}`}>Lifestyle</a>
                        <a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'Entertainment' ? 'active' : ''}`}>Entertainment</a>
                        <a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'Commute' ? 'active' : ''}`}>Commute</a>
                    </nav>
                </div>

                <div className="sub-page" id="add-perks-to-program-page" style={{ width: '90vw' }}>

                    <div className="ui grid" id="perk-management-menu" style={{ width: '90vw' }}>

                        <div className="twelve wide column" style={{}}>
                            {/* <span style={{fontStyle:'SFProText-Regular', fontSize: 14, display: 'flex', flexWrap: 'nowrap'}}>
                                        Attach Teams:
                                    </span> */}
                            {/* <span style={{display: 'flex', width: '100%'}}> */}
                            <Dropdown
                                placeholder='For Teams'
                                multiple
                                fluid
                                search
                                selection
                                options={teamList}
                                onChange={onTeamSelected}
                                value={selectedTeams}
                            />
                            {/* </span> */}
                        </div>
                        <div className="ui four wide column">
                            <div className="ui two column grid">
                                <div className="column right aligned">
                                    <button className="ui button" disabled={existingTeams === selectedTeams} onClick={cancelHandler} 
                                        style={existingTeams !== selectedTeams ? {backgroundColor: '#FCC65C'} : {}} >Cancel</button>
                                </div>
                                <div className="column">
                                    <button className="ui button" disabled={existingTeams === selectedTeams} onClick={setPerksProgramTeamHandler}
                                        style={existingTeams !== selectedTeams ? {backgroundColor: '#00CF8F'} : {}}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="ui grid" style={{ width: '90vw' }}>
                        <div className="ui twelve wide column" style={{ paddingBottom: 0 }}>
                            {/* search code here */}
                            {/* {setCachedPerks(perks)} */}
                            <div className="ui center aligned icon input" style={{ marginLeft: "20%", width: "60%" }}>
                                <i className="search icon"></i>
                                <input type="text" name="name" placeholder="Search" value={searchQuery} onChange={e => {
                                    searchAlgo(e.target.value)
                                }} />
                                {/* {console.log("search query = ", searchQuery)} */}
                            </div>
                            {!perks.length && (<div className="ui segment center aligned"><h5>There are no perks to be displayed.</h5></div>)}
                            {perks.length > 0 &&
                                (<table className="ui single line table perks" style={{ backgroundColor: 'transparent' }}>
                                    <thead style={{ backgroundColor: 'transparent' }}>
                                        <tr style={{ backgroundColor: 'transparent' }}>
                                            <th style={{ backgroundColor: 'transparent' }} className="sortable-column"><span className="sortable-column" onClick={toggleSortProviderNames}>Provider Name<i
                                                className='icon sort alphabet down' /></span></th>
                                            <th style={{ backgroundColor: 'transparent' }} className="sortable-column"><span className="sortable-column" onClick={toggleSortPerkPrices}>Price/employee<i
                                                className='icon sort numeric down' /></span></th>
                                            <th style={{ backgroundColor: 'transparent' }} className="right aligned">
                                                <button className="ui button" onClick={e => approveAllPerks()} style={allowApproveAll ? {backgroundColor: '#00CF8F'} : {}} disabled={!allowApproveAll}>Approve All</button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>



                                        {
                                            // returnedSearch.map(item=>{console.log("map = ", item)})


                                            searchQuery === "" ? perks.map(perk => {
                                                // console.log("algolia perks = ", returnedSearch)
                                                // let test = returnedSearch.map(item=>{
                                                //     item['Provider Name'] == perk.providerName
                                                // })
                                                {/* console.log("perk in renderrrrrrr no search query= ", perk) */ }
                                                let perkToRender = perk;
                                                let matched = programPerks.filter(programPerk => programPerk.id === perk.id);
                                                const matchedPerk = matched.length && matched[0];
                                                // console.info({matchedPerk})
                                                if (matchedPerk) {
                                                    perkToRender = { ...perk, approved: true };
                                                    perkToRender.price = matchedPerk.price;
                                                    // perkToRender.price = matchedPerk.price || perkToRender.price;
                                                    {/* console.info({ perkToRender }) */ }
                                                }
                                                return <Perk programId={id} key={perkToRender.id} {...perkToRender} approved={perkToRender.approved} onApprove={perkAddHandler}
                                                    onRemove={perkRemoveHandler} onUpdate={perkUpdateHandler} />;
                                            })
                                                :
                                                cachedPerks.map(perk => {
                                                    // console.log("algolia perks = ", returnedSearch)
                                                    // let test = returnedSearch.map(item=>{
                                                    //     item['Provider Name'] == perk.providerName
                                                    // })
                                                    {/* console.log("perk in renderrrrrrr= ", perk) */ }
                                                    let perkToRender = perk;
                                                    let matched = programPerks.filter(programPerk => programPerk.id === perk.id);
                                                    const matchedPerk = matched.length && matched[0];
                                                    // console.info({matchedPerk})
                                                    if (matchedPerk) {
                                                        perkToRender = { ...perk, approved: true };
                                                        perkToRender.price = matchedPerk.price;
                                                        // perkToRender.price = matchedPerk.price || perkToRender.price;
                                                        console.info({ perkToRender })
                                                    }
                                                    return <Perk programId={id} key={perkToRender.id} {...perkToRender} approved={perkToRender.approved} onApprove={perkAddHandler}
                                                        onRemove={perkRemoveHandler} onUpdate={perkUpdateHandler} />;
                                                })
                                        }
                                    </tbody>
                                </table>)
                            }
                        </div>

                        <div className="ui four wide column">
                            <div id="budget-acquired-statics">
                                <div className="ui relaxed two column grid">
                                    {/* <div className="column"><h3>Available budget:</h3></div>
                                                <div className="column">${totalAvailableBudget}</div> */}
                                    <div className="column"><h4>Total utilization:</h4></div>
                                    <div className="column"><p>${totalUtilization}</p></div>
                                </div>

                                {/* <Progress percent={totalUtilizationPercentage} warning progress="percent"/> */}
                                <h5 className="category-statics-heading">Utilization By
                                                Category:</h5>
                                <div
                                    className="ui one column grid category-statics-group">
                                    <div className="column category-statics">
                                        <h5>Wellness:</h5>
                                        <Progress className="category-acquired-indicator"
                                            percent={wellnessPerksPercentage} warning progress="percent"
                                            size="small" />
                                    </div>

                                    <div className="column category-statics">
                                        <h5>Productivity:</h5>
                                        <Progress className="category-acquired-indicator"
                                            percent={productivityPerksPercentage} warning progress="percent"
                                            size="small" />
                                    </div>

                                    <div className="column category-statics">
                                        <h5>Training:</h5>
                                        <Progress className="category-acquired-indicator"
                                            percent={trainingPerksPercentage} warning progress="percent"
                                            size="small" />
                                    </div>

                                    <div className="column category-statics">
                                        <h5>Lifestyle:</h5>
                                        <Progress className="category-acquired-indicator"
                                            percent={lifestylePerksPercentage} warning progress="percent"
                                            size="small" />
                                    </div>

                                    <div className="column category-statics">
                                        <h5>Entertainment:</h5>
                                        <Progress className="category-acquired-indicator"
                                            percent={entertainmentPerksPercentage} warning progress="percent"
                                            size="small" />
                                    </div>

                                    <div className="column category-statics">
                                        <h5>Commute:</h5>
                                        <Progress className="category-acquired-indicator"
                                            percent={commutePerksPercentage} warning progress="percent"
                                            size="small" />
                                    </div>
                                </div>

                                <br />

                                <div style={{ marginTop: 15, marginBottom: 15 }} >
                                    <div><h3>Approved Perks</h3></div>
                                    <table className="ui single line table perks" style={{ backgroundColor: 'transparent' }}>
                                        <thead style={{ backgroundColor: 'transparent' }}>
                                            <tr style={{ backgroundColor: 'transparent' }}>
                                                <th style={{ backgroundColor: 'transparent' }}><span onClick={toggleSortProviderNames}>Provider Name<i
                                                    className='icon sort alphabet down' /></span></th>
                                                <th style={{ backgroundColor: 'transparent' }}><span onClick={toggleSortPerkPrices}>Price<i
                                                    className='icon sort numeric down' /></span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {approvedPerks.map((perkItem, index) => {
                                                return <tr key={index} className="perk-item" style={{ backgroundColor: 'rgba(238, 241, 243, 1)' }}>
                                                    <td className="perk-provider">{perkItem.perkName}</td>
                                                    <td>${perkItem.perkPrice}</td>
                                                </tr>
                                            }
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* <div className="ui one column grid">
                                                <div className="column">
                                                    <Checkbox label="Copy Perk Budget Approver" disabled/>
                                                </div>
                                            </div> */}

                                {/* <div className="ui two column grid">
                                                <div className="column right aligned">
                                                    <button className="ui button" disabled={existingTeams === selectedTeams} onClick={cancelHandler}>Cancel</button>
                                                </div>
                                                <div className="column">
                                                    <button className="ui button" disabled={existingTeams === selectedTeams} onClick={setPerksProgramTeamHandler}>Save</button>
                                                </div>
                                            </div> */}

                                {/* <div className="ui one column grid">
                                                <div className="column">
                                                    <a href="#top"
                                                       className="add-a-perk-product-to-perkfix">Add
                                                        a Perk Product to Perkfix.com</a>
                                                </div>
                                            </div> */}
                            </div>
                        </div>
                    </div>

                    <footer>
                    </footer>
                </div>
            </div>

            <Modal dimmer={'blurring'} open={showInfoModal} size="mini">
                <Modal.Content><p>{infoModalText}</p></Modal.Content>
                <Modal.Actions className="center aligned"><Button onClick={e => setShowInfoModal(false)}>Ok</Button></Modal.Actions>
            </Modal>
            <Button icon onClick={() => { myRef.current.scrollIntoView({ behavior: 'smooth' }) }} style={{ position: 'fixed', bottom: 30, right: 30, backgroundColor: 'transparent' }} ><Icon name="arrow alternate circle up" size='big' /></Button>

            {/* --- page ends here --- */}
            {/* </div> */}
            {/* </div>
            </div> */}
        </div>
    );
};

export const AddPerksToProgramPage = AddPerksToProgramPageComponent;
